import { getUser, getToken } from 'shj-utils'
import { message } from 'antd'
import { baseURL } from '@/api'
import { cloneDeep, isArray, pickBy } from 'lodash-es'
import dayjs from 'dayjs'

// const { getUser } = window.microApp?.getData?.() || {}
/**
 * 处理树型结构的数据
 */
export function trans(list) {
  if (!isArray(list)) []
  for (let i = 0; i < list.length; i++) {
    list[i].label = list[i].label
    list[i].title = list[i].label
    list[i].value = list[i].id
    // list[i].key = list[i].id + list[i].label
    if (list[i].children) {
      trans(list[i].children)
    } else {
      list[i].children = list[i].object?.channels || list[i].children || []
      const child = list[i].children
      for (let m = 0; m < child.length; m++) {
        child[m].label = child[m].channelName
        child[m].title = child[m].channelName
        child[m].value = child[m].id
        // child[m].key = child[m].id + child[m].channelName
      }
    }
  }
  return list
}

// 深度优先遍历
export function dfs(
  children: any,
  cb: Function,
  { level = 0, childrenKey = 'children' }: any = {}
): boolean {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      let isBreak = cb && cb(children[i], level)
      if (isBreak) return isBreak
      if (children[i] && children[i][childrenKey]) {
        isBreak = dfs(children[i][childrenKey], cb, { level: level + 1, childrenKey })
      }
      if (isBreak) return isBreak
    }
  }
  return false
}

//根据pdi 将数组重构成树结构
export const convertListToTree = (list: any[], { cb, id = 'id', pid = 'pid' }: any = {}) => {
  const tree: any[] = []

  const map = list.reduce(
    (result: any, item: any) => {
      result[item[id]] = item
      return result
    },
    { 0: {} }
  )
  for (const item of list) {
    cb && cb(item)
    if (item[pid] == 0) {
      tree.push(item)
    } else {
      if (map[item[pid]]) {
        if (!map[item[pid]].children) {
          map[item[pid]].children = []
        }
        map[item[pid]].children.push(item)
      }
    }
  }
  return tree
}

export const getTreeList = (rootList, nid, newArr, type = 'nid') => {
  for (const item of rootList) {
    if (item.parentId == nid) {
      newArr.push(item)
    }
  }
  //给数组里面再添加一个children的空数组
  for (const i of newArr) {
    i.children = []
    getTreeList(rootList, i?.[type], i.children)

    if (i.children.length == 0) {
      delete i.children
    }
  }
  return newArr
}

// 筛选搜索 格式筛选时间
export const filterSerchData = (objOld, dateList, suffixDate = ['Start', 'End']) => {
  if (!isArray(dateList)) return
  const newObj = { ...objOld }
  dateList.map(val => {
    if (isArray(newObj[val]) && newObj[val].length > 0) {
      newObj[val + suffixDate[0]] = dayjs(newObj[val][0]).format('YYYY-MM-DD HH:mm:ss') || ''
      newObj[val + suffixDate[1]] = dayjs(newObj[val][1]).format('YYYY-MM-DD HH:mm:ss') || ''
      delete newObj[val]
    } else if (!newObj[val]) {
      delete newObj[val]
    } else {
      newObj[val] = newObj[val] ? dayjs(newObj[val]).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  })
  return newObj
}
// 表单回显 格式时间
export const momentFormData = (objOld, dateList) => {
  if (!isArray(dateList)) return
  const newObj = { ...objOld }
  dateList.map(val => {
    if (newObj[val]) newObj[val] = dayjs(newObj[val])
  })
  return newObj
} // 上传图片
export const propsDragger = ({
  fileList = [],
  baseUrl,
  fn,
  multiple = false,
  maxCount = 20,
  accept = '.rar,.zip,.doc,.docx,.pdf,.jpg,.png,.cad',
}: any) => {
  return {
    accept: accept,
    name: 'file',
    maxCount: maxCount,
    multiple: multiple,
    action: baseURL + '/file-web/file/upload',
    defaultFileList: fileList || [],
    headers: {
      Authorization: getToken(),
    },
    onChange(info) {
      const fileList_: Record<string, any>[] = []
      info.fileList &&
        info.fileList.forEach(file => {
          if (file.response && file.status == 'done') {
            fileList_.push({
              path: file?.response?.data?.fileUrl,
              name: file?.name,
              type: file?.type,
            })
          }
          // 已存在数据
          if(file.status === 'done' && file.path) fileList_.push(file)
        })
      if (info.file?.status && info.file?.status === 'done') {
        message.success(`${info.file?.name}上传成功`)
      } else if (info.file?.status && info.file?.status === 'error') {
        message.error(`${info.file.name}上传失败`)
      }
      console.log('fileList_', fileList_, info.fileList)
      fn && fn(fileList_)
    },
    onPreview(file) {
      // modalPreviewImageModelFn({
      //   thumbUrl: file.thumbUrl,
      // })
    },
  }
}

export const formatToTree = (ary, pid) => {
  if (!ary || !ary.length) {
    return []
  }
  return ary
    .filter(item =>
      // 如果没有父id（第一次递归的时候）将所有父级查询出来
      // 这里认为 item.parentId === 1 就是最顶层 需要根据业务调整
      pid === undefined ? item.parentId === 1 : item.parentId === pid
    )
    .map(item => {
      // 通过父节点ID查询所有子节点
      item.title = item.name
      // item.title = item.code ? item.code + '-' + item.name : item.name
      item.value = item.id
      item.children = formatToTree(ary, item.id).length > 0 ? formatToTree(ary, item.id) : null
      return item
    })
}

export function matchUrl(staticRoute, dynamicUrl) {
  const staticParts = staticRoute.split('/').filter(Boolean)
  const dynamicParts = dynamicUrl.split('/').filter(Boolean)
  const params = {}

  if (staticParts.length !== dynamicParts.length) {
    return { match: false } // 路径部分数量不匹配
  }

  for (let i = 0; i < staticParts.length; i++) {
    if (staticParts[i].startsWith('{') && staticParts[i].endsWith('}')) {
      const paramName = staticParts[i].slice(1, -1) // 移除花括号
      params[paramName] = dynamicParts[i]
    } else {
      if (staticParts[i] !== dynamicParts[i]) {
        return { match: false } // 静态部分不匹配
      }
    }
  }

  return { match: true, params } // 完全匹配
}

export function setAppTitle() {
  const storeTenantTitle = sessionStorage.getItem('TENANT_TITLE')
  if (storeTenantTitle) {
    document.title = storeTenantTitle
  }
}

// 对象去除空值
export const dealSearch = query => {
  const newQuery = cloneDeep(query)
  const searchValues = pickBy({ ...newQuery })
  const obj_ = {}
  Object.keys(newQuery).forEach(key => {
    if (searchValues[key] === false || searchValues[key] === 0) {
      obj_[key] = searchValues[key]
    }
  })
  return { ...obj_, ...searchValues }
}

// 筛选搜索 格式筛选时间
export const filterSearchData2 = (objOld: any, dateList: any[]) => {
  if (!Array.isArray(dateList)) return objOld
  const newObj = { ...objOld }
  dateList.map(item => {
    const dataIndex: any = newObj[item[0]]
    if (Array.isArray(dataIndex) && dataIndex.length > 0) {
      newObj[item[1]] = dayjs(dataIndex[0]).format('YYYY-MM-DD HH:mm:ss') || ''
      newObj[item[2]] = dayjs(dataIndex[1]).format('YYYY-MM-DD HH:mm:ss') || ''
      delete newObj[item[0]]
    } else if (Array.isArray(dataIndex) && dataIndex.length == 1) {
      newObj.item[0] = dataIndex ? dayjs(dataIndex).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  })
  return newObj
}

/**
 * 递归查询子节点所有父节点
 */
export function getParentId(list, id, key = 'id') {
  if (!isArray(list)) []
  for (const i in list) {
    if (list[i].id == id) {
      return [list[i][key]]
    }
    if (list[i].children) {
      const node = getParentId(list[i].children, id)
      if (node !== undefined) {
        return node.concat(list[i][key])
      }
    }
  }
}

function parseStorage(item, defaultValue = null) {
  if (item && item !== 'undefined') {
    return JSON.parse(item)
  }
  return defaultValue
}

function parseLocalStorage(key, defaultValue: any = null) {
  return parseStorage(localStorage.getItem(key), defaultValue)
}

export const getTheme = () => parseLocalStorage('ANTD_CONFIG_PROVIDER', {})

export const setThemeRoot = theme => {
  const { token, themContent } = theme
  for (const item in themContent) {
    document.documentElement.style.setProperty(item, themContent[item])
  }
}
export function exportFile(res) {
  if (res) {
    let temporary = res.response.headers['content-disposition']
    if (!temporary) return
    temporary = temporary.substring(temporary.indexOf('='))
    temporary = temporary.substring(1, temporary.length)
    const fileName = decodeURI(temporary)
    const blob = new Blob([res.data], { type: res.response.headers['content-type'] })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, fileName)
    } else {
      const URL = window.URL || window.webkitURL
      const objectUrl = URL.createObjectURL(blob)
      if (fileName) {
        const a = document.createElement('a')
        if (typeof a.download === 'undefined') {
          window.location = objectUrl
        } else {
          a.href = objectUrl
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          a.remove()
        }
      } else {
        window.location = objectUrl
      }
    }
  }
}

/**
 * 下载文件确认弹窗
 */
export const fileConfirm = () => {
  const openDownload = window?.microApp?.getData?.()?.openDownload;
  openDownload?.();
}
// 获取租户id
export const getXTransferInsideTenantId = () => {
  return window.localStorage.getItem('X-Transfer-Inside-Tenant-Id') || '';
}

export const filterSearchData = (objOld, dateList, suffixDate = ['Start', 'End']) => {
  if (!isArray(dateList)) return
  const newObj = { ...objOld }
  dateList.map(val => {
    if (isArray(newObj[val]) && newObj[val].length > 0) {
      newObj[val + suffixDate[0]] = dayjs(newObj[val][0]).format('YYYY-MM-DD HH:mm:ss') || ''
      newObj[val + suffixDate[1]] = dayjs(newObj[val][1]).format('YYYY-MM-DD HH:mm:ss') || ''
      delete newObj[val]
    } else if (!newObj[val]) {
      delete newObj[val]
    } else {
      newObj[val] = newObj[val] ? dayjs(newObj[val]).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  })
  return newObj
}
// 金额处理
export function number2money(num) {
  num = num + ''
  let minus = false
  const status = num.search(/\./i)
  if (num < 0) {
    minus = true
    num = num.split('-')[1]
  }
  const num1 = num.split('.')
  num = status == -1 ? num : num1[0]
  let money = formatTextOfSign(num, ',', 3)
  money = status == -1 ? money : money + '.' + num1[1]
  return minus ? '-' + money : money
}
export function formatTextOfSign(num = '', sign = '', size = 0) {
  const numArr = num.toString().split('.')

  const arr = numArr[0].split('')
  if (!size) {
    return num
  }
  for (let i = arr.length - 1, j = 1; i > 0; i--, j++) {
    if (j >= size) {
      arr.splice(i, 0, sign)
      j = 0
    }
  }

  if (numArr[1]) {
    return arr.join('') + '.' + numArr[1]
  }
  return arr.join('')
}
/**
 * 根据key值翻译对应的中文值
 */
export function keyToTitleFn(arr, {key, value, title}) {
  let str = ''
  arr.map(item => {
    if (item[key] == value) {
      str = item[title]
    }
  })
  return str
}
/**
 * 数组转化为对象
 */
export function arrayToObjFn(arr = [], { value, title }) {
  const obj = {}
  arr.map(item => {
    obj[item[value]] = item[title]
  })
  return obj
}
/**
 * 公共联动方法
 */
export const getCommonOptions = async ({
  listRef,
  fn,
  key,
  value = 'code',
  title = 'name',
  // isCode = true,
  isConversion = true,
  allowClear = false,
}) => {
  let data: any = {}
  data = await fn()
  // 是否转化格式
  if (isConversion) {
    data = arrayToObjFn(data, { value, title })
  }
  // 是否清空数据
  if (allowClear) {
    listRef?.current?.resetFields([key])
  }
  listRef?.current?.updateSearchData(key, data)
}

// 根据key 提取数组对应值
export const keysToList = (arrList, arrKey) => {
  if (!isArray(arrList)) return;
  const list = [];
  arrList.map((item) => {
    list.push(item[arrKey]);
  });
  return list || [];
};

export const covertResourceOptions = (
  tree: any,
  {
    topNode = {
      label: '顶级节点',
      value: '0',
    },
    label = 'name',
    value = 'id' }: any = {}
) => {
  const children: any[] = cloneDeep(tree)
  dfs(children, (item: any) => {
    item.label = item?.object?.[label] || item?.[label]
    item.value = item?.object?.[value] || item?.[value]
  })

  if (topNode === false) {
    return children
  }

  const _topNode: any[] = [
    {
      ...topNode,
      children,
    },
  ]
  return _topNode
}

/**
 * 获取当前登录人
 */
export function getNowUserInfo(str = 'company') {
  const info = getUser?.() || {}
  // console.log('getNowUserInfo:::',info);
  let code = ''
  try {
    const fn = {
      company: () => {
        // code = info.currentDepartmentPosition.department.company.code
        code = info.extend.companyCode
      },
      companyName: () => {
        // code = info.currentDepartmentPosition.department.company.name
        code = info.extend.companyName
      },
      deptCode: () => {
        // code = info.currentDepartmentPosition.department.code
        code = info.extend.deptCode || info.userIdentity?.roleCode
      },
      deptCodeName: () => {
        // code = info.currentDepartmentPosition.department.name
        code = info.extend.deptName
      },
      postCode: () => {
        // code = info.currentDepartmentPosition.position.code
        code = info.userIdentity.orgId
      },
      workNumber: () => {
        code = info.workerNumber || info.workNumber
      },
      name: () => {
        code = info.name
      },
      dataLevel: () => {
        code = info.dataLevel
      },
    }[str]
    fn && fn()
  } catch (error) {
  }
  return code
}

export const createURL = (url, obj = {} /*链接和参数*/) => {
  if (url.indexOf('?') == -1) {
    url += '?'
  }
  let param = ''
  Object.keys(obj).map(key => {
    param += key + '=' + obj[key] + '&'
  })
  url += param
  url = url.slice(0, url.length - 1)
  return url
}

//是否总部
export const isHeadquarters = () => {
  const {companyId} = getUser?.() || {}
  // 开发 测试 预生产 生产
  return ['1890666810816196609', '1890666810816196609', '1872899752380338177', '1872899752380338177'].includes(companyId)
}

